import { ITpaSrcBuilder } from 'feature-tpa-commons'
import { IPropsStore, IStructureAPI } from '@wix/thunderbolt-symbols'

type CreateWorkerArgs = {
	props: IPropsStore
	tpaSrcBuilder: ITpaSrcBuilder
	structureApi: IStructureAPI
	workerId: string
	appDefinitionId: string
	appWorkerUrl: string
	appDefinitionName: string
}

type DestroyWorkerArgs = {
	props: IPropsStore
	structureApi: IStructureAPI
	workerId: string
}

const TPA_WORKER_PREFIX = 'tpaWorker'

const tpaWorkerCompIdRegex = new RegExp(`^${TPA_WORKER_PREFIX}_([0-9]+)$`)

export const isTpaWorker = (compId: string) => tpaWorkerCompIdRegex.test(compId)

export const getWorkerApplicationId = (compId: string) => {
	return tpaWorkerCompIdRegex.exec(compId)?.[1]
}

export const getWorkerId = (applicationId: string) => {
	return `${TPA_WORKER_PREFIX}_${applicationId}`
}

export const createWorker = ({
	props,
	tpaSrcBuilder,
	structureApi,
	workerId,
	appDefinitionId,
	appWorkerUrl,
	appDefinitionName,
}: CreateWorkerArgs): void => {
	props.update({
		[workerId]: {
			title: appDefinitionName,
			src: tpaSrcBuilder.buildSrc(workerId, 'masterPage', {}, appWorkerUrl, {
				extraQueryParams: {
					endpointType: 'worker',
				},
				appDefinitionId,
			}),
		},
	})

	structureApi.addComponentToDynamicStructure(workerId, {
		components: [],
		componentType: 'TPAWorker',
	})
}

export const destroyWorker = ({ props, structureApi, workerId }: DestroyWorkerArgs): void => {
	props.update({
		[workerId]: {},
	})

	structureApi.removeComponentFromDynamicStructure(workerId)
}
